import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleDown, faAngleUp, faBars, faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { computed, ref } from "vue";
import { useUserStore } from "@/stores/userStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ListHeader',
    props: {
        showViewToggle: { type: Boolean, default: false }
    },
    setup(__props, { expose }) {
        library.add(faAngleDown, faAngleUp, faBars, faGripVertical);
        const userStore = useUserStore();
        const sortDesc = ref(true);
        const sortBy = ref("update_time");
        const listViewMode = computed(() => userStore.preferredListViewMode || "grid");
        function onSort(newSortBy) {
            if (sortBy.value === newSortBy) {
                sortDesc.value = !sortDesc.value;
            }
            else {
                sortBy.value = newSortBy;
            }
        }
        function onToggleView(newView) {
            userStore.setPreferredListViewMode(newView);
        }
        expose({
            sortBy,
            sortDesc,
            listViewMode,
        });
        return { __sfc: true, userStore, sortDesc, sortBy, listViewMode, onSort, onToggleView, faAngleDown, faAngleUp, faBars, faGripVertical, FontAwesomeIcon, BButton };
    }
});
